import React from 'react'
import ReactDOM from 'react-dom'
import { store, history } from './store'
import Root from './containers/Root'
import { authLoginSuccess } from './actions/auth'
import { adoptSsoSession } from './utils/ssoSession'

const target = document.getElementById('root')

const root = (
  <Root store={store} history={history} />
)

// Adopt a session shared by a sister Vacway platform (cookie on .vacway.es)
// before hydrating: the exchange only hits the network when this app has no
// valid session of its own. See utils/ssoSession.js.
adoptSsoSession().then(() => {
  const token = localStorage.getItem('token')
  if (token !== null) {
    store.dispatch({ ...authLoginSuccess(token), fromStorage: true })
  }

  ReactDOM.render(root, target)
})
